import useSubscriptionQuery from 'api/queries/useSubscriptionQuery';
import useForage from 'contexts/ForageContext/useForage';
import { StepCard, StepHeading } from 'features/shop/cart/EBTPaymentFlow/shared/FlowPresentation';
import EBTCardForm, { useEBTCardOperations } from 'shared/ebt/EBTCardForm';
import { trackEvent, updateProfile } from 'utils/analyticsUtils';

/**
 * @param {Function} handleNext - Callback to proceed to next step
 */
function AddEBTCard({ handleNext }) {
    const { forage } = useForage();
    const { data: subscription = {} } = useSubscriptionQuery();
    const { clearErrors, isSaving, saveCardWithTokenization, saveError } = useEBTCardOperations(subscription?.id);

    return (
        <div className="space-y-20">
            <StepHeading>Add a SNAP EBT Card</StepHeading>
            <p className="text-body-sm">
                To pay with EBT funds, you may add an EBT card anytime during your shopping window. Be sure to manually
                apply your EBT payment before your shopping window closes.
            </p>
            <StepCard className="pt-30">
                <EBTCardForm
                    elementID="ebt-payment-flow-add-card-container"
                    isSaving={isSaving}
                    onSave={async (cardElement) => {
                        await saveCardWithTokenization(forage, cardElement);

                        trackEvent('SNAP card add', {
                            location: 'cart',
                        });
                        updateProfile({ SNAP_enabled: true });

                        handleNext('CreateEBTPayment');
                    }}
                    saveError={saveError}
                    clearErrors={clearErrors}
                    submitButtonText="Continue"
                />
            </StepCard>
        </div>
    );
}

export default AddEBTCard;
